export default __webpack_public_path__ + "fonts/cursor-edit.png";